import {useQuery} from '@tanstack/react-query';
import {getTemplateDataContract} from '@verdocs/js-sdk';
import {
  getDataCatalog,
  getDataCatalogListing,
  getDataCatalogMarketplace,
  getDataCatalogs,
  getDataCatalogUpdate,
  VerdocsEndpoint,
} from '@verdocs/js-sdk';
import {invalidateQuery} from './utils';

export const useDataCatalogs = (organizationId: string) =>
  useQuery({
    enabled: !!organizationId,
    queryKey: ['data_catalogs', organizationId],
    queryFn: () => getDataCatalogs(VerdocsEndpoint.getDefault(), organizationId),
  });

export const useDataCatalog = (organizationId: string, catalogId: string) =>
  useQuery({
    enabled: !!organizationId && !!catalogId,
    queryKey: ['data_catalog', organizationId, catalogId],
    queryFn: () => getDataCatalog(VerdocsEndpoint.getDefault(), organizationId, catalogId),
  });

export const useDataCatalogUpdate = (organizationId: string, catalogId: string) =>
  useQuery({
    enabled: !!organizationId && !!catalogId,
    queryKey: ['data_catalog_update', organizationId, catalogId],
    queryFn: () => getDataCatalogUpdate(VerdocsEndpoint.getDefault(), organizationId, catalogId),
  });

export const useDataCatalogMarketplace = (organizationId: string, q: string) =>
  useQuery({
    enabled: !!organizationId,
    queryKey: ['data_catalog_marketplace', organizationId, q],
    queryFn: () => getDataCatalogMarketplace(VerdocsEndpoint.getDefault(), organizationId, q || undefined),
  });

export const useDataCatalogListing = (organizationId: string, catalogId: string) =>
  useQuery({
    enabled: !!organizationId && !!catalogId,
    queryKey: ['data_catalog_listing', organizationId, catalogId],
    queryFn: () => getDataCatalogListing(VerdocsEndpoint.getDefault(), organizationId, catalogId),
  });

export const useTemplateDataContract = (templateId: string) =>
  useQuery({
    enabled: !!templateId,
    queryKey: ['template_data_contract', templateId],
    queryFn: () => getTemplateDataContract(VerdocsEndpoint.getDefault(), templateId),
  });

export const invalidateDataCatalogs = () => {
  [
    'data_catalogs',
    'data_catalog',
    'data_catalog_update',
    'data_catalog_marketplace',
    'data_catalog_listing',
    'template_data_contract',
  ].forEach((key) => invalidateQuery([key]));
};
